import { KSelect } from ".";
import {
	VBtn,
	VIcon,
	VLabel
} from "vuetify/lib";

export const defaultSelectProps = {
	appendIcon: null,
	flat: true,
	itemText: "name",
	itemValue: "id",
	outlined: true,
	readonly: true,
	solo: true
};

export default {
	name: "KSignableInput",

	props: {
		immutable: Boolean,
		readonly: Boolean,
		selectProps: {
			default: () => defaultSelectProps,
			type: Object
		},
		userSignedBy: Object,
		value: { required: true }
	},

	computed: {
		$_selectProps() {
			return {
				...defaultSelectProps,
				...this.selectProps
			};
		},

		user() {
			return this.$store.getters["auth/user"];
		},

		signableUsers() {
			const users = [];

			if ( this.userSignedBy ) {
				users.push( this.userSignedBy );
			}

			if ( !this.immutable || ( this.immutable && !this.userSignedBy ) ) {
				users.push( this.user );
			}

			return users;
		},

		internalValue: {
			get() {
				return this.value;
			},

			set( val ) {

				// Make sure we don't emit undefined
				this.$emit( "input", val || null );
			}
		},

		locked() {
			return Boolean( this.immutable && this.userSignedBy );
		}
	},

	render() {
		return <div>
			{this.$_selectProps.label && <VLabel>{this.$_selectProps.label}</VLabel>}

			<KSelect
				attrs={this.$_selectProps}
				clearable={!this.locked && !this.readonly}
				disabled={this.locked || this.readonly}
				items={this.signableUsers}
				label={null}
				on={{ "click:clear": () => this.internalValue = null }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				<template slot={this.$_selectProps.solo ? "append" : "append-outer"}>
					{this.locked && <VIcon class="d-print-none">lock</VIcon>}
					{!this.locked && !this.readonly && <VBtn
						class="d-print-none"
						onClick={() => this.internalValue = this.user.id}
						small
						text
					>
						<VIcon left>edit</VIcon> Sign
					</VBtn>}
				</template>

				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</KSelect>
		</div>;
	}
};
